var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBrush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.349,
    x2: 495.503,
    y1: 191.225,
    y2: 493.379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.749,
    x2: 98.295,
    y1: 306.032,
    y2: 208.83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.035,
    x2: 456.802,
    xlinkHref: "#lg1",
    y1: 201.767,
    y2: 454.534
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.883,
    x2: 102.269,
    y1: 346.934,
    y2: 193.268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.704,
    x2: 378.007,
    y1: 193.58,
    y2: 375.883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.428,
    x2: 126.633,
    y1: 348.2,
    y2: 222.468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.343,
    x2: 349.848,
    y1: 208.219,
    y2: 347.724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.59,
    x2: 155.415,
    y1: 330.157,
    y2: 240.102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.536,
    x2: 152.166,
    xlinkHref: "#lg1",
    y1: 71.05,
    y2: 71.05
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.298,
    x2: 195.547,
    y1: 193.026,
    y2: 280.465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.74,
    x2: 97.74,
    xlinkHref: "#lg2",
    y1: 190.665,
    y2: 122.173
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.772,
    x2: 164.586,
    xlinkHref: "#lg2",
    y1: 172.515,
    y2: 348.41
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.004,
    x2: 23.017,
    xlinkHref: "#lg2",
    y1: 218.425,
    y2: 321.115
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.74,
    x2: 97.74,
    xlinkHref: "#lg1",
    y1: 121.319,
    y2: 151.704
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m262.306 23.863v30.189l6 105.395c0 5.583-1.868 12.38 3.679 13.022 42.072 4.872 80.595 46.115 79.566 89.724-1.042 44.169-43.064 86.191-87.233 87.233-46.901 1.107-90.281-42.594-90.281-89.245 0-5.403-.485-10.678.501-15.792h-159.434c-.322 5.221-.493 10.485-.493 15.792 0 136.798 110.896 247.694 247.693 247.694 136.463 0 247.696-111.232 247.695-247.696 0-132.92-104.702-241.387-236.132-247.426-6.307-.29-11.561 4.796-11.561 11.11z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.358 350.425c-46.462.572-90.321-43.913-90.321-90.243 0-5.403.515-10.678 1.501-15.792h-159.434c-.279 4.535-.437 9.103-.476 13.703l248.73 248.73z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.306 54.052v43.499l5 61.896c0 5.583 2.931 13.846 8.477 14.489 42.072 4.872 75.288 44.307 74.259 87.916-1.042 44.169-42.515 84.991-86.684 86.033-46.901 1.107-88.321-41.053-88.321-87.704 0-5.403.515-10.678 1.501-15.792h-119.762c-.38 4.997-.583 10.042-.599 15.137-.354 112.504 90.583 205.135 203.074 206.763 115.244 1.668 209.184-91.246 209.184-206.107 0-113.845-92.285-206.13-206.129-206.13z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.005 304.47 157.044 157.044c13.303 2.931 27.082 4.571 41.202 4.776 1.373.02 2.74.014 4.107.007v-115.872c-46.462.572-89.321-43.913-89.321-90.243 0-5.403.515-10.678 1.501-15.792h-118.762c-.38 4.997-.583 10.042-.599 15.137-.048 15.417 1.628 30.456 4.828 44.943z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.306 96.443v39.924l4 24.081c0 5.583.132 12.38 5.679 13.022 42.072 4.872 78.595 45.115 77.566 88.724-1.042 44.169-41.064 84.191-85.233 85.233-46.901 1.107-90.281-40.594-90.281-87.245 0-5.403.515-10.678 1.501-15.792h-76.221c-.493 5.2-.75 10.464-.75 15.792 0 90.43 73.308 163.739 163.738 163.739 90.347.001 163.742-73.395 163.741-163.741-.002-90.429-73.311-163.737-163.74-163.737z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.304 423.921c.352 0 .702-.011 1.054-.013v-75.483c-46.462.572-89.321-41.913-89.321-88.243 0-5.403.515-10.678 1.501-15.792h-76.221c-.493 5.2-.75 10.464-.75 15.792-.001 90.43 73.308 163.739 163.737 163.739z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.306 136.174v30.274c0 5.583 4.132 10.38 9.679 11.022 42.072 4.872 74.595 41.115 73.566 84.724-1.042 44.169-37.064 80.191-81.233 81.233-46.901 1.107-85.281-36.594-85.281-83.245 0-5.403.515-10.678 1.501-15.792h-41.243c-.654 5.167-.997 10.442-.997 15.792 0 69.073 56.481 124.961 125.776 123.996 66.789-.93 121.297-55.439 122.228-122.228.965-69.295-54.923-125.776-123.996-125.776z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.358 384.178v-40.753c-46.462.572-84.321-36.913-84.321-83.243 0-5.403.515-10.678 1.501-15.792h-41.243c-.654 5.167-.997 10.442-.997 15.792 0 68.835 56.093 124.568 125.06 123.996z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.451 2.124h-27.423c-11.891 0-21.53 9.639-21.53 21.53v4.85c0 10.253 1.529 20.449 4.538 30.251 3.008 9.802 4.538 19.998 4.538 30.251v50.97h52.33v-50.97c0-10.253 1.529-20.449 4.538-30.251 3.008-9.802 4.538-19.998 4.538-30.251v-4.85c.001-11.891-9.639-21.53-21.529-21.53z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.034 142.003v113.937c0 2.343 1.899 4.242 4.242 4.242h19.925c1.725 0 3.278-1.044 3.928-2.641l3.367-8.264c1.471-3.61 6.624-3.492 7.926.183l2.801 7.899c.6 1.693 2.202 2.824 3.998 2.824h45.248c1.619 0 3.096-.921 3.809-2.375l3.528-7.196c1.239-2.528 4.553-3.17 6.646-1.286 1.854 1.668 4.741 1.385 6.235-.613l1.985-2.654c2.134-2.854 6.623-1.964 7.506 1.488l2.418 9.446c.481 1.877 2.172 3.19 4.109 3.19h35.497c2.343 0 4.242-1.899 4.242-4.242v-113.938z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.034 158.341 96.633 96.633 2.139-4.364c1.239-2.528 4.553-3.17 6.646-1.286 1.854 1.668 4.741 1.385 6.235-.613l1.985-2.654c2.134-2.854 6.623-1.964 7.507 1.488l2.418 9.446c.481 1.877 2.172 3.19 4.109 3.19h35.497c2.343 0 4.242-1.899 4.242-4.242v-113.936h-167.411z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.065 142.003h-130.65v118.179h5.786c1.725 0 3.278-1.044 3.928-2.642l3.367-8.264c1.471-3.61 6.624-3.492 7.926.183l2.801 7.899c.6 1.693 2.202 2.824 3.998 2.824h45.248c1.619 0 3.096-.921 3.809-2.375l3.528-7.196c1.239-2.528 4.553-3.17 6.646-1.286 1.854 1.668 4.741 1.385 6.235-.613l1.985-2.654c2.134-2.854 6.623-1.964 7.507 1.488l2.418 9.446c.481 1.877 2.172 3.19 4.109 3.19h21.358v-118.179z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.529 142.003h-65.579v118.179h40.52c1.619 0 3.096-.921 3.809-2.375l3.528-7.196c1.239-2.528 4.553-3.17 6.646-1.286 1.854 1.668 4.741 1.385 6.235-.613l1.985-2.654c.748-1 1.787-1.531 2.857-1.663z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.277 157.51h-169.075c-7.291 0-13.202-5.911-13.202-13.202v-8.782c0-7.291 5.911-13.202 13.202-13.202h169.075c7.291 0 13.202 5.911 13.202 13.202v8.782c0 7.291-5.911 13.202-13.202 13.202z",
    fill: "url(#SVGID_14_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrush);
export default __webpack_public_path__ + "static/media/icon-brush.a6c28fcd158d741d62ae73382e4898ed.svg";
export { ForwardRef as ReactComponent };